import React from "react";
import { LegalPage } from "./legal/LegalPage";

const Ouvidoria = () => <LegalPage namespace="legalOuvidoria" />;

export default Ouvidoria;
